import { render, staticRenderFns } from "./UserRolesCard.vue?vue&type=template&id=02c1147a&scoped=true"
import script from "./UserRolesCard.vue?vue&type=script&lang=ts"
export * from "./UserRolesCard.vue?vue&type=script&lang=ts"
import style0 from "./UserRolesCard.vue?vue&type=style&index=0&id=02c1147a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c1147a",
  null
  
)

export default component.exports